/**
 * Allow only same-app relative paths (blocks open redirects).
 * Returns null when missing or unsafe so callers can keep their default destination.
 */
export function getSafeRedirectPath(
  raw: string | null | undefined
): string | null {
  if (!raw) return null;
  const path = raw.trim();
  if (!path.startsWith("/") || path.startsWith("//")) return null;
  return path;
}
